jQuery(function($) {
    toggleBanner();

    $('[data-shortlist-toggle]').each(function() {
        let id = $(this).attr('data-shortlist-toggle');

        let promise = idInShortlist(id);

        promise.done(function(data) {
            if(data) {
                let response = $.parseJSON(data).response;

                if(response) {
                    if(response.error) {
                        console.log(response.error);
                        return;
                    }

                    $('[data-shortlist-toggle="' + id + '"]').text('In your Shortlist');
                    $('[data-shortlist-toggle="' + id + '"]').attr('data-shortlist-action', 'remove');
                }
            }
        });
    });

    $('[data-shortlist-toggle]').on('click', function(e) {
       e.preventDefault();
         $('body').trigger('shortlist_toggle', $(this));
    });

    $('body').on('shortlist_toggle', function(obj, el) {
        let id = $(el).attr('data-shortlist-toggle');
        // console.log(id);

        let action = $(el).attr('data-shortlist-action');

        switch (action) {
            case 'add':
                $(el).attr('data-shortlist-action', 'remove');
                $(el).text('In your Shortlist');
                $('body').trigger('shortlist_add', id);
                addToShortlist(id);
            break;
                case 'remove':
                $(el).attr('data-shortlist-action', 'add');
                $(el).text('Add to Shortlist');
                $('body').trigger('shortlist_remove', id);
                removeFromShortlist(id);
            break;
        }
    });

    function idInShortlist(id) {
        let endpoint = 'brochure';
        let action = 'check';
        let post_id = 'id';
        let to_return = false;

        return $.ajax({
            url: '?brochure=check&id=' + id,
        }).done(function(data) {
            if(data.error === false) {
                let response = $.parseJSON(data).response;
            } else {
                let response = false;
            }
        });
    }

    function addToShortlist(id, expertise_id=null) {
        // console.log('add to shortlist', id);
        let endpoint = 'brochure';
        let action = 'add';
        let post_id = 'post_id';
        let url = '?'+endpoint+'='+action+'&'+post_id+'='+id;

        if(expertise_id) {
            url += '&expertise_id=' + expertise_id;
            url += '&addOverview=true';
        }

        let promise = $.ajax({
            url: url
        });

        promise.done(function(data) {
            toggleBanner();
        });
    }

    function removeFromShortlist(id, expertise_id=null) {
        // console.log('In your Shortlist', id);
        let endpoint = 'brochure';
        let action = 'remove';
        let post_id = 'post_id';
        let url = '?'+endpoint+'='+action+'&'+post_id+'='+id;

        if(expertise_id) {
            url += '&expertise_id=' + expertise_id;
        }

        let promise = $.ajax({
            url: url
        });

        if($('body').hasClass('brochure')) {
            $('[data-shortlist-toggle="' + id + '"]').closest('.barrister').fadeOut(function() {
                $(this).remove();
            })
        }

        promise.done(function(data) {
            toggleBanner();
        });
    }

    function toggleBanner() {
        let show_banner = false;
        let count = 0;

        let promise = idInShortlist(0);

        promise.done(function(data) {
            let response = $.parseJSON(data);

            if(response.error) {
                console.log(response.error);
                return;
            }

            // get count of items
            let count = 0;

            for(let key in response) {
                // console.log(key);
                count++;
            }

            if(count > 0) {
                let plural = false;
                let text = count;

                $('.shortlist-count').text(text);

                if(count > 1) {
                    plural = true;
                }

                if(plural) {
                    let text = 's';
                    $('.shortlist-plural').text(text);
                } else {
                    let text = '';
                    $('.shortlist-plural').text(text);
                }

                $('.shortlist-banner').addClass('open');
            } else {
                $('.shortlist-banner').removeClass('open');
            }

            return count;
        });
    }

    $('.barrister-modal__areas-of-expertise__checkbox>label>input[type="checkbox"]').on('change', function() {
        let num_checked = $('.barrister-modal__areas-of-expertise__checkbox>label>input[type="checkbox"]:checked').length;

        let barrister_id = $(this).data('barrister-id');
        let expertise_id = $(this).data('expertise-id');
        let checked = $(this).prop('checked');

        if(checked) {
            $('body').trigger('shortlist_add', barrister_id, expertise_id);
            addToShortlist(barrister_id, expertise_id);
        } else {
            $('body').trigger('shortlist_remove', barrister_id, expertise_id);
            removeFromShortlist(barrister_id, expertise_id);
        }

        if(num_checked) {
            $('.custom-cv-download').removeAttr('disabled');
        } else {
            $('.custom-cv-download').attr('disabled', true);
        }
    });

    $('body').on('shortlist_add shortlist_remove', function(e, data) {
        console.table([data]);
        let shortlist_banner_state = $('.shortlist-banner').hasClass('minimised');
        let duration = 1;

        $('.shortlist-count').hide();

        if(e.type === 'shortlist_add') {
            $('.shortlist-count')
                .css('color', 'var(--color-Teal-52)');
        }

        if(e.type === 'shortlist_remove') {
            $('.shortlist-count')
                .css('color', '#73221C');
        }

        $('.shortlist-count').fadeIn();

        setTimeout(function() {
            $('.shortlist-count')
                .css('color', '#404040');
        }, 1.1 * 1000);

        if(shortlist_banner_state) {
            $('.shortlist-banner').removeClass('minimised');

            setTimeout(function() {
                $('.shortlist-banner').addClass('minimised');
            }, duration * 1000);
        }
    });

    let shortlist_banner_state = localStorage.getItem('shortlist-banner-state');

    if(shortlist_banner_state === 'minimised') {
        $('.shortlist-banner').addClass('minimised');
    } else {
        $('.shortlist-banner').removeClass('minimised');
    }

    $('.banner-toggle').on('click', function(e) {
        e.preventDefault();

        // Toggle shortlist-banner-state local storage value
        let stored_state = localStorage.getItem('shortlist-banner-state');
        let banner_state = $('.shortlist-banner').hasClass('minimised');
        let state = banner_state ? 'maximised' : 'minimised';

        localStorage.setItem('shortlist-banner-state', state);
        $('.shortlist-banner').toggleClass('minimised');
    });
});